<template>
  <li class="card">
    <h3 class="card-text text-center-card" :class="{ 'mb-home': isMarging}">{{ title }}</h3>
    <p class="card-description">{{ description }}</p>
  </li>
</template>
<script>
  export default {
    name: "Card",
    props: {
      title: String,
      description: String,
      isMarging: Boolean,
      isCenter: Boolean
    }
  };
</script>

<style lang="scss" scoped>
  .card {
    max-width: 20rem;
    min-height: 400px;
    flex-wrap: wrap;
    background: #FCFAF8;
    border-radius: 8px;
    border: none;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease-in-out;
    padding: 1rem;
    flex-grow: 1;
    transition: transform 0.3s ease, box-shadow 0.3s ease;


    .card-text {
      min-height: 4.5em;
      line-height: 1.5em;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .mb-home {
      margin-bottom: 70px !important;
    }

    @media (max-width: 480px) {
      .text-center-card {
        text-align: center !important;
      }

    }
  }

      @media (max-width: 480px) {
      .card {
        min-height: 300px;

      .mb-home {
      margin-bottom: 30px !important;
    }
      }
      
    }

  .card:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  }
</style>